module.exports = __webpack_public_path__ + "img/icon_5_43.9f228940.png";